import React, {FC} from 'react';

import classNames from 'classnames';

import {UHC_COOKIE} from 'constants/uhc';
import {BrandsLogo} from 'desktop/components/brandsLogo/brandsLogo';

import {getCurrentUhcCookie} from 'libs/getCurrentUhcCookie/getCurrentUhcCookie';

import s from './cartUhcLogo.scss';

type CartUhcLogoType = {
    brand?: keyof typeof UHC_COOKIE.VALUES;
};

const BRANDS_BACKGROUND: Record<keyof typeof UHC_COOKIE.VALUES, string> = {
    LFG: s.lfg,
    MEDIGOLD: s.medigold,
    SOLSTICE: s.solstice,
    SPECTERA: s.spectera,
    UHC: s.uhc,
};

/**
 * UHC banner for SideBar
 */
export const CartUhcLogo: FC<CartUhcLogoType> = ({brand = getCurrentUhcCookie()}) => {
    return (
        <div className={classNames(s.wrapper, brand && BRANDS_BACKGROUND[brand])}>
            <div className={s.logo}>
                <BrandsLogo brand={brand} />
            </div>
        </div>
    );
};
